<template>
  <div
    data-qa="stars_rating_row"
    class="rating-row align-center"
    :class="pill
      ? 'rating-row--pill d-inline-flex align-center gc-3 rounded-20 border-sm pa-3'
      : ['d-flex ga-2 flex-wrap', centered && 'w-100 justify-center']"
  >
    <template v-if="pill">
      <div class="d-flex align-center gc-1 flex-shrink-0">
        <span
          data-qa="stars_rate"
          class="ui-icon-rating-star-filled ui-icon-fz-medium rating--text flex-shrink-0"
        />
        <span class="text-subtitle-1 text--text text-no-wrap">
          {{ formatRatingScore(solidity) }}
        </span>
      </div>
    </template>
    <RatingBadge
      v-else
      :solidity="solidity"
    />
    <CorePRG
      v-if="reviewsHref"
      :url="reviewsHref"
      :form-attrs="{
        target: '_self',
        class: 'd-inline',
      }"
      :button-attrs="reviewsButtonAttrs"
    >
      <template v-if="reviewsCount > 0">
        {{ formattedReviewsCount }} {{ reviewsLabel }}
      </template>
      <template v-else>
        {{ noReviewsLabel }}
      </template>
    </CorePRG>
  </div>
</template>

<script lang="ts" setup>
/**
 * Строка рейтинга: badge и опциональный PRG-переход на отзывы.
 *
 * `pill` — звезда, оценка и ссылка в одной bordered-капсуле (шапка branding).
 * При `reviewsCount === 0` и наличии `reviewsHref` показывается «Нет отзывов».
 */
import { computed } from 'vue'
import I18NextVue from 'i18next'
import formatRatingScore from 'common/filters/formatRatingScore'
import declensionByNum from 'src/utils/declensionByNum'
import RatingBadge from 'src/components/common/RatingBadge/RatingBadge.vue'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'

const { t, language } = I18NextVue
const l10nOptions = { ns: language }

const props = withDefaults(defineProps<{
  solidity: number
  reviewsHref?: string
  reviewsCount?: number
  centered?: boolean
  pill?: boolean
}>(), {
  pill: false,
  reviewsHref: undefined,
  reviewsCount: undefined,
})

const reviewsCount = computed(() => props.reviewsCount ?? 0)
const formattedReviewsCount = computed(() => reviewsCount.value.toLocaleString('ru-RU'))
const reviewsLabel = computed(() => (
  t(declensionByNum(reviewsCount.value, ['отзыв', 'отзыва', 'отзывов']), l10nOptions)
))
const noReviewsLabel = computed(() => t('Нет отзывов', l10nOptions))

const reviewsButtonAttrs = computed(() => ({
  'data-qa': 'stars_rating_reviews_link',
  class: [
    'rating-row__reviews',
    'primary--text',
    'text-decoration-none',
    'link-decoration-none',
    'text-no-wrap',
    'button-reset',
    props.pill ? 'text-body-1' : 'text-body-2',
  ].join(' '),
}))
</script>
